import axios from 'axios'
import { sendSendApplicationErrorNotification, sendSendApplicationNotification } from 'fe2/web2ClientAPI/notifications'
import { t } from 'helpers/localization'
import get from 'lodash/get'

export const PURPOSES = {
    NO_OBLIGATIONS: 'no_obligations',
    SQUAD_BATTLES: 'squad_battles',
    CLAN_BATTLES: 'clan_battles',
}

export const PURPOSE_TITLES = {
    [PURPOSES.NO_OBLIGATIONS]: t('Никаких обязательств'),
    [PURPOSES.SQUAD_BATTLES]: t('Игра в отряде'),
    [PURPOSES.CLAN_BATTLES]: t('Клановые бои'),
}

export const AVAILABLE_PURPOSES = [PURPOSES.NO_OBLIGATIONS, PURPOSES.SQUAD_BATTLES, PURPOSES.CLAN_BATTLES]

export type RecommendationsPurpose = PURPOSES.NO_OBLIGATIONS | PURPOSES.SQUAD_BATTLES | PURPOSES.CLAN_BATTLES

export const PurposesMap = {[PURPOSES.NO_OBLIGATIONS]: 0, [PURPOSES.SQUAD_BATTLES]: 1, [PURPOSES.CLAN_BATTLES]: 2}
export const PurposesMapReversed = {0: PURPOSES.NO_OBLIGATIONS, 1: PURPOSES.SQUAD_BATTLES, 2: PURPOSES.CLAN_BATTLES}

export type clanData = {
    tag: String,
    name: string,
    color: string,
    description: string,
    rawDescription: string,
    id: number,
}

export type AccountRecommendationsSettings = {
    languages: Array<String>,
    useVoiceChat: Boolean,
}

export type ClanRecommendationsSettings = {
    languages: Array<String>,
    purpose: RecommendationsPurpose,
    isRecommendable: Boolean,
    isVoiceChatRequired: Boolean,
}

export type ClanRecommendation = {
    maxMemberCount: number,
    memberCount: number,
    color: String,
    status: String,
    tag: String,
    languages: Array<String>,
    similarity: number,
    isVoiceRequired: Boolean,
    id: number,
    doesSentAnInvite: Boolean,
    name: String,
}

export type GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_TYPE = 'GET_ACCOUNT_RECOMMENDATIONS_SETTINGS'
export const GET_ACCOUNT_RECOMMENDATIONS_SETTINGS: GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_TYPE = 'GET_ACCOUNT_RECOMMENDATIONS_SETTINGS'

export type GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE'
export const GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE: GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE'

export const getAccountRecommendationsSettings = () => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: GET_ACCOUNT_RECOMMENDATIONS_SETTINGS,
    })
    // todo: use urls from settings
    axios.get('/api/clanrec2/account_settings/').then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: GET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE,
                payload: {languages: response.data.languages, useVoiceChat: response.data.useVoiceChat === 0},
            })
        }
    })
}

export type SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_TYPE = 'SET_ACCOUNT_RECOMMENDATIONS_SETTINGS'
export const SET_ACCOUNT_RECOMMENDATIONS_SETTINGS: SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_TYPE = 'SET_ACCOUNT_RECOMMENDATIONS_SETTINGS'

export type SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE'
export const SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE: SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE'

export const setAccountRecommendationsSettings = (recommendationsSettings: AccountRecommendationsSettings) => (dispatch: Dispatch, getState: GetState) => {
    const settings = {
        languages: recommendationsSettings.languages,
        useVoiceChat: recommendationsSettings.useVoiceChat ? 0 : 2,
    }

    dispatch({
        type: SET_ACCOUNT_RECOMMENDATIONS_SETTINGS,
        payload: settings,
    })

    axios.put('/api/clanrec2/account_settings/', settings).then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: SET_ACCOUNT_RECOMMENDATIONS_SETTINGS_RESPONSE,
                payload: {languages: response.data.languages, useVoiceChat: response.data.useVoiceChat === 0},
            })
        }
    })
}

export type GET_CLAN_RECOMMENDATIONS_SETTINGS_TYPE = 'GET_CLAN_RECOMMENDATIONS_SETTINGS'
export const GET_CLAN_RECOMMENDATIONS_SETTINGS: GET_CLAN_RECOMMENDATIONS_SETTINGS_TYPE = 'GET_CLAN_RECOMMENDATIONS_SETTINGS'

export type GET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'GET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE'
export const GET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE: GET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'GET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE'

export const getClanRecommendationsSettings = () => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: GET_CLAN_RECOMMENDATIONS_SETTINGS,
    })

    axios.get('/api/clanrec2/clan_settings/').then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: GET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE,
                payload: {
                    languages: response.data.languages,
                    purpose: get(PurposesMapReversed, response.data.purpose, PURPOSES.NO_OBLIGATIONS),
                    isRecommendable: response.data.isRecommendable,
                    isVoiceChatRequired: response.data.isVoiceChatRequired,
                },
            })
        }
    })
}

export type SET_CLAN_RECOMMENDATIONS_SETTINGS_TYPE = 'SET_CLAN_RECOMMENDATIONS_SETTINGS'
export const SET_CLAN_RECOMMENDATIONS_SETTINGS: SET_CLAN_RECOMMENDATIONS_SETTINGS_TYPE = 'SET_CLAN_RECOMMENDATIONS_SETTINGS'

export type SET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'SET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE'
export const SET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE: SET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE_TYPE = 'SET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE'

export const setClanRecommendationsSettings = (recommendationsSettings: ClanRecommendationsSettings) => (dispatch: Dispatch, getState: GetState) => {
    const settings = {
        languages: recommendationsSettings.languages,
        purpose: get(PurposesMap, recommendationsSettings.purpose, 0),
        isRecommendable: recommendationsSettings.isRecommendable,
        isVoiceChatRequired: recommendationsSettings.isVoiceChatRequired,
    }

    dispatch({
        type: SET_CLAN_RECOMMENDATIONS_SETTINGS,
        payload: settings,
    })

    axios.put('/api/clanrec2/clan_settings/', settings).then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: SET_CLAN_RECOMMENDATIONS_SETTINGS_RESPONSE,
                payload: {
                    languages: response.data.languages,
                    purpose: get(PurposesMapReversed, response.data.purpose, PURPOSES.NO_OBLIGATIONS),
                    isRecommendable: response.data.isRecommendable,
                    isVoiceChatRequired: response.data.isVoiceChatRequired,
                },
            })
        }
    })
}

export type GET_RECOMMENDATIONS_TYPE = 'GET_RECOMMENDATIONS'
export const GET_RECOMMENDATIONS: GET_RECOMMENDATIONS_TYPE = 'GET_RECOMMENDATIONS'

export type GET_RECOMMENDATIONS_RESPONSE_TYPE = 'GET_RECOMMENDATIONS_RESPONSE'
export const GET_RECOMMENDATIONS_RESPONSE: GET_RECOMMENDATIONS_RESPONSE_TYPE = 'GET_RECOMMENDATIONS_RESPONSE'

export const getRecommendations = (purpose: RecommendationsPurpose) => (dispatch: Dispatch, getState: GetState) => {
    const purposeValue = PurposesMap[purpose]

    dispatch({
        type: GET_RECOMMENDATIONS,
    })

    axios.get(`/api/clanrec2/?purpose=${purposeValue}`).then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: GET_RECOMMENDATIONS_RESPONSE,
                payload: response.data.items,
            })
        }
    })
}

export type GET_LEFT_APPLICATION_COUNT_TYPE = 'GET_LEFT_APPLICATION_COUNT'
export const GET_LEFT_APPLICATION_COUNT: GET_LEFT_APPLICATION_COUNT_TYPE = 'GET_LEFT_APPLICATION_COUNT'

export type GET_LEFT_APPLICATION_COUNT_RESPONSE_TYPE = 'GET_LEFT_APPLICATION_COUNT_RESPONSE'
export const GET_LEFT_APPLICATION_COUNT_RESPONSE: GET_LEFT_APPLICATION_COUNT_RESPONSE_TYPE = 'GET_LEFT_APPLICATION_COUNT_RESPONSE'

export const getLeftApplicationCount = () => (dispatch: Dispatch, getState: GetState) => {

    dispatch({
        type: GET_LEFT_APPLICATION_COUNT,
    })

    axios.get('/api/clanrec2/left_application_count/').then((response) => {
        if (response.status === 200 && response.data) {
            dispatch({
                type: GET_LEFT_APPLICATION_COUNT_RESPONSE,
                payload: response.data.leftApplicationCount,
            })
        }
    })
}

export type SEND_APPLICATION_TYPE = 'SEND_APPLICATION'
export const SEND_APPLICATION: SEND_APPLICATION_TYPE = 'SEND_APPLICATION'

export type SEND_APPLICATION_RESPONSE_TYPE = 'SEND_APPLICATION_RESPONSE'
export const SEND_APPLICATION_RESPONSE: SEND_APPLICATION_RESPONSE_TYPE = 'SEND_APPLICATION_RESPONSE'

export const sendApplication = (clan: ClanRecommendation, info: String) => (dispatch: Dispatch, getState: GetState) => {
    dispatch({
        type: SEND_APPLICATION,
    })

    axios.post('/api/clanrec2/application/', {clanId: clan.id, comment: info}).then((response) => {
        if (response.status >= 200 && response.status < 300 && response.data) {
            sendSendApplicationNotification({name: clan.name, tag: clan.tag, color: clan.color})

            dispatch({
                type: SEND_APPLICATION_RESPONSE,
                payload: {status: true, clan},
            })
        }
    }).catch((error) => {
        if (error.response.data) {
            const reason = get(error.response.data, 'title', '').toLowerCase()
            sendSendApplicationErrorNotification(reason, clan)
        }

        dispatch({
            type: SEND_APPLICATION_RESPONSE,
            payload: {status: false, clan},
        })
    })
}